export const UNDEFINED_ENUM = 'UNDEFINED_ENUM';
